<template>
  <f7-popup id="saveUserActivityLog" class="popup-side popup-save" :tablet-fullscreen="false" :backdrop="true" :close-by-backdrop-click="false">
    <f7-page>
      <template #fixed>
        <NavigationPopupSideComponent :title="title" @close-popup="closePopup" />
      </template>

      <FormComponent ref="formComponent" @successSave="closePopup" />
    </f7-page>
  </f7-popup>
</template>

<script>
import { defineComponent, ref, inject } from "vue";
import { f7 } from "framework7-vue";

import { useStore } from "@/store";
import { helpers } from "@/utils/helpers.js";

const store = useStore();

import NavigationPopupSideComponent from "@/components/NavigationPopupSideComponent.vue";
import FormComponent from "@/components/FormComponent.vue";

export default defineComponent({
  name: "UserActivityLogSavePartial",
  components: {
    NavigationPopupSideComponent,
    FormComponent,
  },
  props: {},
  emits: ["opened", "closed"],
  setup(props, { emit }) {
    const title = ref("");
    const $t = inject("$translation");

    const formComponentData = {
      buttonText: "",
      getLink: "/admin/useractivitylog/view",
      getParams: {},
      validation: "useractivitylog",
      saveLink: "/admin/useractivitylog/save",
      saveParams: {},
      successCreateMessage: $t.getTranslation("LBL_SUCCESS_CREATE_USER_ACTIVITY_LOG"),
      successUpdateMessage: $t.getTranslation("LBL_SUCCESS_UPDATE_USER_ACTIVITY_LOG"),
    };

    const defaultInputList = [
      {
        name: $t.getTranslation("LBL_USER_ACTIVITY_LOG_INFORMATION"),
        type: "input",
        list: [
          {
            name: $t.getTranslation("LBL_ACTIVITY_TYPE"),
            type: "select",
            value: "Type",
            required: true,
            hideClearButton: true,
            items: store.getters["config/getData"]?.userActivityLogTypeList,
            nameSelector: "name",
            valueSelector: "value",
            defaultValue: "SERVICE",
          },
          { name: $t.getTranslation("LBL_CONTENT"), type: "textarea", value: "Content", required: true },
          { name: $t.getTranslation("LBL_ACTIVITY_DATE"), type: "date", value: "ActivityDate", required: false, hideClearButton: true },
        ],
      },
      {
        name: $t.getTranslation("LBL_STATUS_INFORMATION"),
        type: "input",
        list: [{ name: "Status", type: "select", value: "StatusCode", required: false, hideClearButton: true, items: store.getters["config/getData"]?.statusList, nameSelector: "Name", valueSelector: "Code", defaultValue: "ACTIVE" }],
      },
    ];

    return {
      title,
      formComponentData,
      defaultInputList,
    };
  },
  methods: {
    async openPopup(data) {
      const self = this;
      self.formComponentData.inputList = helpers.cloneDeep(self.defaultInputList);

      if (data?.UserActivityLogId) {
        self.title = this.$t.getTranslation("LBL_UPDATE_USER_ACTIVITY_LOG");
        self.formComponentData.buttonText = this.$t.getTranslation("LBL_UPDATE_USER_ACTIVITY_LOG");
        self.formComponentData.getParams.UserActivityLogId = data?.UserActivityLogId;

        self.formComponentData.saveParams.UserId = data?.UserId;
        self.formComponentData.saveParams.UserActivityLogId = data?.UserActivityLogId;

        self.$refs.formComponent.setFormComponentData(self.formComponentData, true);
      } else {
        self.title = this.$t.getTranslation("LBL_CREATE_USER_ACTIVITY_LOG");
        self.formComponentData.buttonText = this.$t.getTranslation("LBL_CREATE_USER_ACTIVITY_LOG");
        self.formComponentData.getParams = {};
        self.formComponentData.saveParams = {
          UserId: data.UserId,
        };

        self.$refs.formComponent.setFormComponentData(self.formComponentData);
      }

      f7.popup.open("#saveUserActivityLog");
      self.$emit("opened", true);
    },
    closePopup(data) {
      f7.popup.close("#saveUserActivityLog");
      this.$emit("closed", data);
    },
  },
});
</script>
